<template>
  <div class="history">
    <!-- card -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>权重配置（评估）</span>
        <!-- <el-button type="primary" icon="el-icon-edit" @click="showDialog"
          >权重系数</el-button
        > -->
        <el-button class="tz-r tz-create-btn" type="primary" round @click="add"
          >添加</el-button
        >
      </div>
      <!-- 筛选 -->
      <el-row>
        <!-- <el-col :span="2">
          <div style="height: 40px; line-height: 40px">
            <el-radio v-model="type" label="0" @change="getNewList"
              >评估</el-radio
            > -->
        <!-- <el-radio v-model="type" label="1" @change="getOldList"
              >检测</el-radio
            >
            <el-radio v-model="type" label="2" @change="getOldList"
              >检查</el-radio
            > -->
        <!-- </div>
        </el-col> -->
        <!-- 时间选择 -->
        <!-- <el-col :span="5">
          <el-date-picker
            v-model="monthValue"
            type="month"
            placeholder="请选择时间"
            format="yyyy 年 MM 月"
            value-format="yyyy-MM"
            @change="handleDateChange"
          >
          </el-date-picker>
        </el-col> -->
        <!-- 类型下拉 -->
        <el-col :span="5">
          <el-select
            class="select"
            clearable
            v-model="deviceTypeValue"
            placeholder="请选择设备类型"
            @change="changeDeviceType"
          >
            <el-option
              v-for="item in deviceTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <!-- 搜索 -->
        <!-- <el-col :span="1">
          <el-button
            icon="el-icon-search"
            type="primary"
            plain
            @click="getWeightList"
          ></el-button>
        </el-col> -->
        <el-col :span="13">&nbsp;</el-col>
        <!-- <el-col :span="1"
          ><el-button
            icon="el-icon-circle-plus-outline"
            type="warning"
            plain
            @click="add"
            >添加</el-button
          ></el-col
        > -->
        <!-- <el-col :span="1">&nbsp;</el-col> -->
      </el-row>
      <!-- 筛选 -->

      <!-- 表格 -->
      <!-- <TzTable :tableData="tableData" :columns="columns" /> -->
      <el-table :data="tableData" border style="width: 100%" ref="table">
        <el-table-column
          v-for="(item, i) in column"
          :key="i"
          :prop="item.prop"
          :label="item.label"
          sortable
        >
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              @click="handleEditClick(scope.row)"
              type="primary"
              size="small"
              >编辑</el-button
            >
            &nbsp;
            <el-popconfirm
              title="确认删除该权重配置吗？"
              @confirm="deleteWeight(scope.row)"
            >
              <el-button slot="reference" type="danger" size="small"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <!-- 弹框 -->
      <el-dialog
        title="权重系数配置"
        width="40%"
        center
        :visible.sync="dialogFormVisible"
        destroy-on-close
      >
        <el-form
          style="width: 80%"
          :model="equipmentForm"
          :ref="equipmentForm"
          label-width="120px"
          inline-message
        >
          <!-- <el-form-item label="时间：">
            <el-date-picker
              style="width: 100%"
              v-model="equipmentForm.dialogPickerDate"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :editable="false"
              :clearable="false"
              @change="handleDialogDateChange"
            >
            </el-date-picker>
          </el-form-item> -->
          <el-form-item label="设备类型：">
            <el-select
              placeholder="请选择设备类型"
              style="width: 100%"
              class="select"
              :disabled="!isadd"
              v-model="equipmentForm.dialogdDeviceTypeValue"
              @change="changedialogDeviceType"
            >
              <el-option
                v-for="item in dialogDeviceTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="权重值：">
            <el-input
              style="width: 100%"
              clearable
              v-model="equipmentForm.weight"
              type="digit"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item v-if="type == 1" label="校核权重：">
            <el-input
              style="width: 100%"
              clearable
              v-model="equipmentForm.reviewWeight"
              type="digit"
            ></el-input>
          </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button
            type="primary"
            @click="isadd ? addWeight() : updateWeight()"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <!-- card -->
  </div>
</template>

<script>
import {
  pageWeight,
  queryDict,
  updateWeight,
  deleteWeight,
  saveWeight
} from '@/api/workload'

export default {
  components: {},

  data() {
    // var checkWeight = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error('权重值不能为空'))
    //   } else if (isNaN(value)) {
    //     return callback(new Error('权重值必须为数字值'))
    //   }
    // }
    return {
      dialogFormVisible: false,
      type: '0', //1检测，2检查
      offset: '', //当前起始位置（page-1）*limit
      page: 1, //当前页
      limit: '10', //
      total: 0,
      // pickerDate: [], //日期 时间戳
      notNum: false,
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > Date.now()
        }
      },
      monthValue: '', //月份
      deviceTypeList: [], //设备类型下拉
      dialogDeviceTypeList: [], //弹窗设备类型下拉

      deviceTypeValue: '', //选中类型
      // 表格固定列
      column: [
        {
          prop: 'deviceTypeName',
          label: '设备名称'
        },
        // {
        //   label: '启用时间',
        //   prop: 'startDt'
        // },
        // {
        //   prop: 'endDt',
        //   label: '结束时间'
        // },
        {
          prop: 'weight',
          label: '权重值'
        }
        // {
        //   prop: 'reviewWeight',
        //   label: '校核权重'
        // }
      ],

      // 表格数据
      tableData: [],
      equipmentForm: {
        weight: '', //权重值
        reviewWeight: '', //校核权重
        dialogPickerDate: [], //弹窗时间
        dialogdDeviceTypeValue: '', //弹窗选中类型名字
        deviceType: '',
        id: ''
      },
      isadd: false, //弹窗ture为添加
      formLabelWidth: '150px'
      // rules: {
      //   weight: [{ validator: checkWeight, trigger: 'blur' }],
      //   dialogdDeviceTypeValue: [
      //     { message: '请选择设备类型', trigger: 'blur' }
      //   ],
      //   dialogPickerDate: [{ message: '请选择日期', trigger: 'change' }]
      // }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.limit = val
      this.getWeightList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getWeightList()
    },
    //选择日期事件
    handleDateChange(pickerDate) {
      console.log(pickerDate)
      this.page = 1
      this.getWeightList()
    },

    //Dialog选择日期事件
    handleDialogDateChange(pickerDate) {
      console.log(pickerDate)
      this.equipmentForm.dialogPickerDate = pickerDate
    },

    //获取设备类型
    queryDict() {
      // let dictData = ['equipment_type']
      let dictData = ['equipment_type_other']
      queryDict(dictData).then((res) => {
        console.log(res.data, '设备类型')
        this.deviceTypeList = res.data
        this.dialogDeviceTypeList = res.data
      })
    },
    //获取评估设备类型
    queryDictOther() {
      let dictotherData = ['equipment_type_other']
      queryDict(dictotherData).then((res) => {
        console.log(res.data, '设备类型')
        this.deviceTypeList = res.data
        this.dialogDeviceTypeList = res.data
      })
    },
    //设备类型下拉
    changeDeviceType(value) {
      this.deviceTypeValue = value
      console.log(this.deviceTypeValue, '类型')
      this.page = 1
      this.getWeightList()
    },
    //弹窗类型下拉
    changedialogDeviceType(value) {
      this.equipmentForm.deviceType = value
      console.log(this.equipmentForm.deviceType, '类型')
    },
    //获取数据
    getWeightList() {
      // console.log(this.monthValue, this.monthValue.length)
      // if (this.monthValue && this.monthValue.length <= 7) {
      //   this.monthValue = this.monthValue + '-01'
      // }
      console.log(this.deviceTypeValue)
      var data = {
        // endDt: this.monthValue,
        offset: (this.page - 1) * this.limit,
        limit: this.limit,
        type: this.type,
        deviceType:
          this.deviceTypeValue == '' ? null : Number(this.deviceTypeValue),
        reviewWeight: this.reviewWeight
      }
      console.log(data)
      pageWeight(data).then((res) => {
        console.log(res.data, '权重')
        this.tableData = res.data.rows
        this.total = res.data.total
      })
    },
    // 点击评估单选框
    getNewList() {
      this.column = [
        {
          prop: 'deviceTypeName',
          label: '设备名称'
        },
        {
          label: '启用时间',
          prop: 'startDt'
        },
        {
          prop: 'endDt',
          label: '结束时间'
        },
        {
          prop: 'weight',
          label: '权重值'
        }
      ]
      this.queryDictOther()
      this.getWeightList()
    },
    // 点击检测检查单选框
    getOldList() {
      if (this.type == 1) {
        this.column = [
          {
            prop: 'deviceTypeName',
            label: '设备名称'
          },
          {
            label: '启用时间',
            prop: 'startDt'
          },
          {
            prop: 'endDt',
            label: '结束时间'
          },
          {
            prop: 'weight',
            label: '权重值'
          }
          // {
          //   prop: 'reviewWeight',
          //   label: '校核权重'
          // }
        ]
      } else {
        this.column = [
          {
            prop: 'deviceTypeName',
            label: '设备名称'
          },
          {
            label: '启用时间',
            prop: 'startDt'
          },
          {
            prop: 'endDt',
            label: '结束时间'
          },
          {
            prop: 'weight',
            label: '权重值'
          }
        ]
      }
      this.queryDict()
      this.getWeightList()
    },
    // // 点击搜索
    // search() {
    //   console.log(this.monthValue)
    //   this.getWeightList()
    // },
    // 显示弹窗编辑信息
    handleEditClick(row) {
      this.isadd = false
      console.log(row, 'row')
      this.dialogFormVisible = true
      this.equipmentForm.dialogPickerDate = [row.startDt, row.endDt]
      this.equipmentForm.dialogdDeviceTypeValue = row.deviceTypeName
      this.equipmentForm.weight = row.weight
      this.equipmentForm.deviceType = row.deviceType
      this.equipmentForm.id = row.id
    },

    //弹窗 修改 确定
    updateWeight() {
      //修改
      var data = {
        type: this.type,
        deviceType: this.equipmentForm.deviceType,
        startDt: this.equipmentForm.dialogPickerDate[0],
        endDt: this.equipmentForm.dialogPickerDate[1],
        weight: this.equipmentForm.weight,
        id: this.equipmentForm.id
      }
      console.log(data, '修改')
      updateWeight(data).then((res) => {
        console.log(res)
        if (res.code == '200' && res.msg == '处理成功') {
          this.$message({
            message: '修改成功',
            type: 'success',
            duration: 4000
          })
          setTimeout(() => {
            this.dialogFormVisible = false
          }, 1000)
          this.getWeightList()
        } else if (res.code == '402') {
          this.$message({
            message: res.data,
            duration: 4000
          })
        }
      })
    },
    //添加弹窗
    add() {
      this.closeDialog()
      this.isadd = true
      this.dialogFormVisible = true
    },
    addWeight() {
      var data = {
        type: this.type,
        // startDt: this.equipmentForm.dialogPickerDate[0],
        // endDt: this.equipmentForm.dialogPickerDate[1],
        weight: this.equipmentForm.weight,
        deviceType: this.equipmentForm.deviceType
      }
      // if (data.startDt == '' || data.startDt == undefined) {
      //   alert('日期不能为空')
      // } else
      if (data.deviceType == '') {
        alert('设备类型不能为空')
      } else if (data.weight == '') {
        alert('权重不能为空')
      } else if (isNaN(data.weight)) {
        alert('权重需为数字')
      } else {
        console.log(data, '添加')
        saveWeight(data).then((res) => {
          console.log(res)
          if (res.code == '200' && res.msg == '处理成功') {
            this.$message({
              message: '添加成功',
              type: 'success',
              duration: 4000
            })
            setTimeout(() => {
              this.dialogFormVisible = false
            }, 1000)
            this.getWeightList()
          } else if (res.code == '402') {
            this.$message({
              message: res.data,
              duration: 4000
            })
          }
        })
      }
    },

    //删除
    deleteWeight(row) {
      // console.log(row, 'row')
      deleteWeight({ id: row.id }).then((res) => {
        console.log(res)
        if (res.code == '200' && res.msg == '处理成功') {
          this.$message({
            message: '删除成功',
            type: 'success',
            duration: 4000
          })

          this.getWeightList()
        }
      })
    },
    //关闭弹窗
    closeDialog() {
      ;(this.dialogFormVisible = false),
        (this.equipmentForm.weight = ''), //权重值
        (this.equipmentForm.dialogPickerDate = [])
      ;(this.equipmentForm.dialogdDeviceTypeValue = ''), //弹窗选中类型名字
        (this.equipmentForm.deviceType = ''),
        (this.equipmentForm.id = '')
    }
  },
  created() {
    this.queryDict()
    // this.getWeightList()
  },
  mounted() {
    this.getWeightList()
  }
}
</script>

<style lang="scss" scoped>
.clearfix {
  display: flex;
  justify-content: space-between;
}
</style>
